import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from './modules/auth'
import notification from './modules/notification'
import admin from './modules/admin'

const store = new Vuex.Store({
  modules: {
    auth,
    notification,
    admin
  }
})

export default store
